import { Environment } from '@chewy/header-footer-react/dist/components/react/src/utils/env.util';

export function getHeaderEnvironment(env: string): Environment {
  switch ((env || '').toLowerCase()) {
    case 'stg':
      return Environment.STG;
    case 'qat':
      return Environment.QAT;
    case 'prd':
      return Environment.PROD;
    case 'dev':
    default:
      return Environment.DEV;
  }
}

export function getHeaderEnvironmentUrl(env: Environment): string {
  switch (env) {
    case Environment.LOCAL:
      // @ts-expect-error global state object type is unknown
      return `http://localhost:${globalThis.HEADER_FOOTER_SPA_PORT || 3000}`;
    case Environment.DEV:
      return 'https://www-dev.chewy.net';
    case Environment.STG:
      return 'https://www-stg.chewy.net';
    case Environment.QAT:
      return 'https://www-qat.chewy.net';
    case Environment.PROD:
      return 'https://www.chewy.com';
  }
  return '';
}
